import React from 'react';

import {
  Grid,
} from '@mui/material';

import { Student } from '../../../../services/students/types';
import { Metadata } from '../../../../services/types';

import BillingCreditsCard from './BillingCreditsCard';
import BillingNotesCard from './BillingNotesCard';
import BillingSettingsCard from './BillingSettingsCard';
import DiscountsCard from './DiscountsCard';

interface BillingTabProps {
  student?: Student,
  studentMetadata?: Metadata,
}

const BillingTab = ({ student, studentMetadata }: BillingTabProps) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <DiscountsCard student={student} />
    </Grid>
    <Grid item xs={12}>
      <BillingSettingsCard student={student} studentMetadata={studentMetadata} />
    </Grid>
    <Grid item xs={12}>
      <BillingNotesCard student={student} />
    </Grid>
    <Grid item xs={12}>
      <BillingCreditsCard courseStates={student?.courseStates || {}} student={student} />
    </Grid>
  </Grid>
);

export default BillingTab;
